import React from 'react'
import cn from 'classnames'

export interface MenuItemType {
  megaMenu?: any[]
  subMenu?: MenuItemType[]
  title: string
  url?: string
  id?: string
}

const Dropdown: React.FC<{
  expand: boolean
  onRenderItem: (item: MenuItemType, key: number) => JSX.Element
  items?: MenuItemType[]
}> = ({ expand, items, onRenderItem }) => {
  if (!items) {
    return null
  }

  return (
    <div
      className={cn('dropdown', {
        'dropdown--expanded': expand
      })}
      style={{
        transform: `translateY(${(items.length - 0.9) * 50}px)`,
        height: `${items.length * 50}px`
      }}
    >
      {items.map((item, key) => onRenderItem(item, key))}
      {/* {items.map(
        (item, idx) =>
          onRenderLink ? (
            onRenderLink(<h6>{item.title}</h6>)
          ) : (
            <a href={item.url} className='dropdown__item'>
              <h6>{item.title}</h6>{' '}
            </a>
          )
        <Link key={idx} to={item.url} className='dropdown__item' activeClassName='dropdown__item--active'>
          <h6>{item.title}</h6>
        </Link>
      )} */}
    </div>
  )
}

export default Dropdown
